import { useContext } from 'react';
import { PhotoDraftContext } from './photo-draft-context';
import type { PhotoDraftStore } from './photo-draft-types';

export const usePhotoDraftStore = (): PhotoDraftStore => {
  const store = useContext(PhotoDraftContext);
  if (!store) throw new Error('PhotoDraftProvider가 필요합니다.');
  return store;
};
